<template>
  <div class="login-page">
    <aside class="login-page__brand">
      <img src="@/assets/logo-pbb-white.png" alt="Paoli Balbino & Balbino Administração Judicial" />
      <div class="login-page__brand-text">
        <span class="login-page__eyebrow">{{ brand.eyebrow }}</span>
        <p>{{ brand.text }}</p>
      </div>
    </aside>

    <main class="login-page__main">
      <div class="login-page__form">
        <img class="login-page__logo-mobile" src="@/assets/logo-paoli.png" alt="Paoli Balbino & Balbino Administração Judicial" />

        <h1 class="title-login">{{ brand.title }}</h1>
        <p class="login-page__subtitle">{{ brand.subtitle }}</p>

        <v-form ref="form" v-model="loginForm.validForm" lazy-validation @submit.prevent="login">
          <v-text-field placeholder="Digite seu e-mail" label="E-mail" ref="username" outlined autocomplete="username"
            :rules="[$rules.required, $rules.email]" v-model="loginForm.user.username"></v-text-field>

          <v-text-field outlined label="Senha" :append-icon="loginForm.showPassword ? 'mdi-eye' : 'mdi-eye-off'"
            required :rules="[$rules.required]" :type="loginForm.showPassword ? 'text' : 'password'"
            autocomplete="current-password" v-model="loginForm.user.password"
            @click:append="loginForm.showPassword = !loginForm.showPassword" hide-details="auto" id="password"></v-text-field>

          <div class="login-page__forgot">
            <a class="btn-forgot-password" @click.prevent="openForgotPassword">Esqueci minha senha</a>
          </div>

          <v-btn block x-large color="primary" elevation="0" :loading="loginForm.loading" type="submit">Entrar</v-btn>
        </v-form>
      </div>
    </main>

    <v-dialog v-model="forgot.dialog" max-width="480">
      <v-card>
        <v-card-title>Recuperar senha</v-card-title>
        <v-card-text>
          <p>Informe o e-mail de acesso. Se ele estiver cadastrado, enviaremos um link para criar uma nova senha.</p>
          <v-form ref="forgotForm" @submit.prevent="forgotPassword">
            <v-text-field outlined label="E-mail" v-model="forgot.email" :rules="[$rules.required, $rules.email]"
              hide-details="auto"></v-text-field>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="forgot.dialog = false">Cancelar</v-btn>
          <v-btn color="primary" elevation="0" :loading="forgot.loading" @click="forgotPassword">Enviar link</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Vue from "vue";
import axios from 'axios';
import router from '../router';
import * as jwt from "jwt-decode";

export default {
  name: "Login",

  data: () => ({
    brand: {
      eyebrow: "Administração judicial",
      text: "Gestão dos casos, credores, habilitações e assembleias em um só lugar.",
      title: "Acesso administrativo",
      subtitle: "Informe seu e-mail e senha para acessar o painel.",
    },
    page: {
      slogan: null,
    },
    username: "",
    password: "",
    loading: false,
    valid: true,
    show: false,
    rules: {
      email: [
        (v) => !!v || "O usuário é obrigatório",
        // (v) =>
        //   (v && v.length <= 25) ||
        //   "O usuário deve ter menos de 10 caracteres",
      ],
      password: [(v) => !!v || "A senha é obrigatória"],
    },
    forgot: {
      dialog: false,
      loading: false,
      email: "",
    },
    loginForm: {
      validForm: true,
      showPassword: false,
      loading: false,
      user: {},
    },
  }),

  mounted() {
    if (this.$route.query.username) {
      this.loginForm.user.username = this.$route.query.username;
    }
  },

  methods: {
    empty() {
      return (
        !this.$data.loginForm.user.username ||
        !this.$data.loginForm.user.password
      );
    },
    async login() {

      if (!this.$refs.form.validate()) return;

      let data = {
        email: this.loginForm.user.username,
        password: this.loginForm.user.password,
        type: 2,
      };

      this.$data.loginForm.loading = true;

      try {
        const result = await axios.post('/api/admin/login', data);

        if (!result.data.status) throw new Error();

        localStorage.setItem('token', JSON.stringify(result.data.content));

        var dataUser = jwt(result.data.content.token);

        console.log('dataUser', dataUser)

        this.$root.user = dataUser.data;
        localStorage.setItem('user', JSON.stringify(dataUser));

        router.push("/home");

      } catch (error) {
        console.log('error ', error)
        this.$dialog.notify.error(this.$codes(error), { position: 'top-right', timeout: 5000 });
        this.$data.loginForm.user.password = "";
      } finally {
        this.$data.loginForm.loading = false;
      }
    },

    openForgotPassword() {
      this.forgot.email = this.loginForm.user.username || "";
      this.forgot.dialog = true;
    },

    async forgotPassword() {
      if (!this.$refs.forgotForm.validate()) return;

      this.forgot.loading = true;

      try {
        await axios.post('/api/admin/forgot-password', { email: this.forgot.email });

        this.forgot.dialog = false;
        this.$dialog.notify.info("Se o e-mail estiver cadastrado, você receberá um link para criar uma nova senha.", { position: 'top-right', timeout: 6000 });
      } catch (error) {
        this.$dialog.notify.error(this.$codes(error), { position: 'top-right', timeout: 5000 });
      } finally {
        this.forgot.loading = false;
      }
    },

  },
};
</script>

<style scoped lang="scss">
.login-page {
  display: flex;
  min-height: 100vh;
  background: #fff;
}

.login-page__brand {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 44%;
  max-width: 620px;
  padding: 56px;
  background: linear-gradient(160deg, var(--v-primary-base), var(--v-navyDeep-base));
  color: #fff;

  img {
    width: 220px;
    max-width: 70%;
  }
}

.login-page__brand-text p {
  max-width: 380px;
  text-align: left;
  margin: 12px 0 0;
  font-size: 22px;
  line-height: 1.4;
  color: rgba(255, 255, 255, 0.86);
}

.login-page__eyebrow {
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: var(--v-copper-base);
}

.login-page__main {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 40px 24px;
}

.login-page__form {
  width: 100%;
  max-width: 400px;
}

.login-page__logo-mobile {
  display: none;
  width: 150px;
  margin-bottom: 32px;
}

.title-login {
  color: var(--v-primary-base);
  font-family: 'Avenir LT Std';
  font-size: 32px;
  font-weight: 700;
  line-height: 1.2;
  margin: 0;
}

.login-page__subtitle {
  margin: 8px 0 32px;
  color: var(--v-muted-base);
}

.login-page__forgot {
  display: flex;
  justify-content: flex-end;
  margin: 10px 0 24px;
}

.btn-forgot-password {
  cursor: pointer;
  font-size: 14px;
  font-weight: 600;
  color: var(--v-primary-base);

  &:hover {
    text-decoration: underline;
  }
}

@media (max-width: 960px) {
  .login-page__brand {
    display: none;
  }

  .login-page__logo-mobile {
    display: block;
  }
}
</style>
